import { render, staticRenderFns } from "./Overview.vue?vue&type=template&id=f2df20fc&scoped=true&"
import script from "./Overview.vue?vue&type=script&lang=ts&"
export * from "./Overview.vue?vue&type=script&lang=ts&"
import style0 from "./Overview.vue?vue&type=style&index=0&id=f2df20fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2df20fc",
  null
  
)

export default component.exports